$(function() {
  function trackOrder(e) {
    e.preventDefault();
    let internal = $(this).attr('data-tracking-url-internal');
    let external = $(this).attr('data-tracking-url-external');
    if (internal && internal !== '') {
      window.location.href = internal;
    } else if (external && external !== '') {
      window.open(external, '_blank');
    }
  }
  $('.tracking-button').on('click', trackOrder);
});

const mediaxs = window.matchMedia('(max-width: 576px)');
const mediasm = window.matchMedia('(min-width: 576px) and (max-width: 1024px)');
const orderStatus = parseInt(
  $('.order-tracker__tooltip--heading').text().length
);
const orderdateRow = $('.orderDateCol');
const statusRow = $('.order-tracker__tooltip--heading').text();
const tooltipRow = $('.order-tracker__tooltip');
const statusBox = $('.Orderstatus');

function assignPadding() {
  if (mediaxs.matches) {
    if (orderStatus > 16) {
      orderdateRow.addClass('mt-5');
    } else if (statusRow === 'Processing Order') {
      $(statusBox).removeClass('col-xs-5');
      $(statusBox).addClass('col-xs-4');
      orderdateRow.addClass('mt-5');
    }
  }
  if (mediasm.matches) {
    if (orderStatus > 16) {
      orderdateRow.addClass('mt-5');
    } else if (statusRow === 'Processing Order') {
      $(tooltipRow).removeClass('ml-3');
      $(tooltipRow).addClass('ml-1');
    }
  }
}

function convertDateToClientFormat(dateClientFormat) {
  return (
    ('0' + (dateClientFormat.getMonth() + 1)).slice(-2) +
    '/' +
    ('0' + dateClientFormat.getDate()).slice(-2) +
    '/' +
    dateClientFormat.getFullYear()
  );
}

function initOrderDateFormat() {
  let $ele;
  let dateUtcFormat;
  let dateClientFormat;
  let finalDateFormat;
  let $eleDate;
  $('[name="orderDetailsForm"]').each((index, element) => {
    $ele = $(element);
    $eleDate = $ele.find('.orderDetailsPlacedDate');
    if ($eleDate.text() !== '') {
      dateClientFormat = new Date(new Date(`${$eleDate.text()}`));
      finalDateFormat = convertDateToClientFormat(dateClientFormat);
      $eleDate.removeClass('hidden');
      $eleDate.text(finalDateFormat);
    }
  });
}

$(document).ready(function() {
  assignPadding();
  if ($('[name="orderDetailsForm"]').length) {
    initOrderDateFormat();
  }
});
